var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgQuestionMarkCircled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.592,
    d: "M19.13 9.963a9.168 9.168 0 1 0-18.335 0 9.168 9.168 0 0 0 18.336 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.903 14.722a.99.99 0 0 1-.67-.248c-.19-.165-.286-.397-.286-.695 0-.265.092-.486.276-.666a.934.934 0 0 1 .68-.27c.263 0 .485.09.665.27.181.18.27.401.27.666 0 .293-.094.524-.282.692a.956.956 0 0 1-.653.251m-3.069-6.89c0-.397.128-.802.384-1.21.255-.409.628-.747 1.12-1.015.49-.268 1.062-.403 1.715-.403.606 0 1.144.113 1.61.337.465.224.824.53 1.077.914.253.386.38.805.38 1.258 0 .356-.071.668-.215.936-.146.27-.318.5-.517.695-.198.195-.555.522-1.071.984-.143.13-.257.245-.343.342a1.488 1.488 0 0 0-.192.27 1.324 1.324 0 0 0-.097.246 7.932 7.932 0 0 0-.104.43c-.08.437-.328.655-.748.655a.767.767 0 0 1-.55-.215c-.148-.142-.222-.353-.222-.634 0-.352.053-.657.162-.914.11-.258.254-.484.434-.68.181-.195.423-.427.73-.694.267-.236.461-.412.58-.532.12-.12.221-.252.302-.4a.96.96 0 0 0 .123-.477c0-.335-.125-.618-.373-.85-.25-.228-.572-.344-.966-.344-.461 0-.801.116-1.017.349-.22.233-.403.575-.555 1.027-.142.474-.412.712-.81.712a.8.8 0 0 1-.596-.25c-.16-.166-.24-.344-.24-.536"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgQuestionMarkCircled);
export default ForwardRef;